import { Component, contentChildren, input } from "@angular/core";
import { PageToolbarItemType } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  standalone: false,
  selector: "snt-page-toolbar-group",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarGroupComponent
    }
  ]
})
export class PageToolbarGroupComponent {
  type: PageToolbarItemType = "group";

  title = input<string | undefined>(undefined);

  items = contentChildren<PageToolbarItemComponent>(PageToolbarItemComponent);
}
